export const CtaBarButtonType = {
  URL_TO_ANOTHER_PAGE: 0,
  LINK_TO_MARKETO: 1,
  ANCHOR_TO_MARKETO_FORM: 2,
  LINK_OR_UPLOAD_ASSET: 3,
};
